export const addRecurlyDependencies = () => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://js.recurly.com/v4/recurly.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = 'https://js.recurly.com/v4/recurly.js';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

let stripeDependencyPromise;

export const addStripeDependencies = () => {
  if (window.Stripe) {
    return Promise.resolve();
  }

  if (stripeDependencyPromise) {
    return stripeDependencyPromise;
  }

  const existingScript = document.querySelector('script[src="https://js.stripe.com/v3"]');

  stripeDependencyPromise = new Promise((resolve, reject) => {
    if (existingScript) {
      existingScript.addEventListener('load', resolve, { once: true });
      existingScript.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = 'https://js.stripe.com/v3';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return stripeDependencyPromise;
};

export const addSolidgateDependencies = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = 'https://cdn.solidgate.com/js/solid-form.js';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const addPaddleDependencies = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = 'https://cdn.paddle.com/paddle/paddle.js';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const addTruegateDependencies = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = process.env.REACT_APP_TRUEGATE_SDK_URL;
    script.onload = () => {
      console.log('Truegate SDK loaded');
      resolve();
    };
    script.onerror = (err) => {
      console.error('Truegate SDK failed to load', err);
      reject(err);
    };
    document.head.appendChild(script);
  });
};
